import * as api from '../../services/credit_type/api_credit_type';
import * as apiCommon from '../../services/apiCommon';
import { browserHistory } from 'react-router';
import { delay, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import * as common from '../sagasCommon';
import * as DocType from '../../constants/constant_doc_types';
import * as SagasType from '../../constants/constant_saga_types';


export function* fetchListCreditTypeSaga(feathersApp) {
	yield takeLatest('FETCH_LIST_CREDIT_TYPE', callFetchListCreditType, feathersApp);
}

function* callFetchListCreditType(feathersApp, action) {
	const { silent, filters } = action;
	yield common.showProgressListTable(silent);
	try {
		const dataParams = {
			filters,
			list_type: 'credit_type'
		};
		const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
		yield call(common.doneListTable, { rows: tableData.data, total_rows: tableData.total });
	} catch (error) {
		yield common.showErrorListTable(error);
	}
}


export function* saveCreditTypeSaga(feathersApp) {
	yield takeEvery("SAVE_CREDIT_TYPE", callSaveCreditType, feathersApp);
}
function* callSaveCreditType(feathersApp, action) {
	const { tenant, user } = yield select();
	try {
		yield put({ type: 'SAVE_RECORD_INPROGRESS' });

		const params = { tenant, user, data: action.data };
		const result = yield call(api.saveCreditType, feathersApp, params);
		yield common.doneSaveRecord(result, 'Credit type was saved');
		yield put({
			type: SagasType.SIMPLE_FORM_SET_DATA,
			data: result
		});
		yield callFetchListCreditType(feathersApp, { silent: true });

	} catch (e) {
		yield common.showErrorSaveRecord(e);
	}
}

export function* deleteCreditTypeFromListSaga(feathersApp) {
	yield takeEvery('DELETE_CREDIT_TYPE_FROM_LIST', callDeleteCreditTypeFromList, feathersApp);
}

function* callDeleteCreditTypeFromList(feathersApp, action) {
	yield deleteCreditType(feathersApp, action);
	yield delay(2000);
	yield callFetchListCreditType(feathersApp, { silent: true });
}

function* deleteCreditType(feathersApp, action) {
	yield put({ type: 'DELETE_RECORD_INPROGRESS' });
	try {
		const { id } = action;
		let result = null;
		if (id) {
			const state = yield select();
			const { tenant, user } = state;
			const params = { tenant, user, id };
			result = yield call(api.deleteCreditType, feathersApp, params);
			yield put({ type: "DELETE_RECORD_DONE", payload: { id, docType: DocType.CREDIT_TYPE } });
			yield callFetchListCreditType(feathersApp, { silent: true });
		}
		return result;
	} catch (error) {
		yield put({ type: 'DELETE_RECORD_ERROR', error })
	}
}

export function* deleteCreditTypeSaga(feathersApp) {
	yield takeEvery('DELETE_CREDIT_TYPE', callDeleteCreditType, feathersApp);
}

function* callDeleteCreditType(feathersApp, action) {
	const result = yield deleteCreditType(feathersApp, action);
	yield delay(2000);
	if (result) {
		browserHistory.push('/admin/credit_type');
	}
}

export function* fetchCreditTypeForEditSaga(feathersApp) {
	yield takeEvery('FETCH_CREDIT_TYPE_BY_ID', callFetchCreditTypeForEdit, feathersApp);
}

function* callFetchCreditTypeForEdit(feathersApp, action) {
	const { tenant, user } = yield select();
	const { id } = action;
	const docType = DocType.CREDIT_TYPE;
	try {
		if (id) {
			yield put({ type: "FETCH_DATA_BY_ID_INPROGRESS", payload: { docType, id } });
			const fetchParams = { tenant, user, id };
			const doc = yield call(api.fetchCreditTypeById, feathersApp, fetchParams);
			yield common.doneDataById(doc);
			yield put({
				type: SagasType.SIMPLE_FORM_SET_DATA,
				data: doc
			});
		}
	} catch (error) {
		yield put({ type: "FETCH_DATA_BY_ID_ERROR", error: error });
	}
}
